import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import Api from "./Api";
import { EspecialidadeDTO } from "./cadastro/saude/EspecialidadeDTO";
import { servicosSaudeApiConfig } from "./config";

class ServicosSaudeEspecialidadeApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  // Usado no preenchimento de autocomplete
  pesquisarEspecialidade(nome: string): Promise<EspecialidadeDTO[]> {
    return this.get<EspecialidadeDTO[]>(`/especialidades/listar-todas-por/${nome}`)
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw new Error("Falha ao consultar especialidades");
      });
  }

  obterEspecialidades(filtro: any) {
    return this.get("/especialidades", {
      params: filtro,
    })
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw err;
      });
  }

  salvarEspecialidade(especialidade: any): Promise<string> {
    return this.post<EspecialidadeModel>("/especialidades", especialidade)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  atualizarEspecialidade(idEspecialidade: Number, especialidade: any): Promise<string> {
    return this.put<any>(`/especialidades/${idEspecialidade}`, especialidade)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }

  obterEspecialidadePorId(idEspecialidade: Number): Promise<any> {
    return this.get(`/especialidades/${idEspecialidade}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error("Falha ao obter especialidade.");
      });
  }

  deletarEspecialidade(idEspecialidade: Number): Promise<any> {
    return this.delete(`/especialidades/${idEspecialidade}`)
      .then((registered: AxiosResponse) => {
        const { data } = registered;
        return data;
      })
      .catch((error: AxiosError) => {
        throw new Error(error.response?.data.detail);
      });
  }
}

export const servicosSaudeEspecialidadeApi = new ServicosSaudeEspecialidadeApi(servicosSaudeApiConfig);
